import { connect } from "react-redux";
import { getDisplayableItemCount } from "../../../../state/selectors";
import ItemCount from "../../../presentational/common/ItemCount";

const mapStateToProps = state => ({
  itemCount: getDisplayableItemCount(state)
});

export default connect(mapStateToProps)(ItemCount);
